import { PAYABLE, RECEIVABLE } from "@/constants";

export const SET_ALL_INVOICES = "addAllInvoices";
export const INVOICES_LOADING = "setLoadingInvoices";
export const INVOICES_LOADED = "removeLoadingInvoices";
export const RESET = "reset";
export const RESET_PAGES = "resetPages";

export const mutations = {
  [RESET_PAGES](state) {
    state.activePage = 1;
    state.totalPages = 0;
    state.totalRows = 0;
  },
  [SET_ALL_INVOICES](state, payload) {
    state.activePage = payload.paginationData.activePage;
    state.totalPages = payload.paginationData.totalPages;
    state.totalRows = payload.paginationData.totalRows;
    state.allInvoices = payload.data.map((invoice) => {
      // split into receivables n payables
      if (invoice.receivable === "True") {
        delete invoice.receivable;
        return {
          ...invoice,
          type: RECEIVABLE,
        };
      } else {
        delete invoice.receivable;
        return {
          ...invoice,
          type: PAYABLE,
        };
      }
    });
  },
  [INVOICES_LOADING](state) {
    state.loadingInvoices = true;
  },
  [INVOICES_LOADED](state) {
    state.loadingInvoices = false;
  },
  [RESET](state) {
    state.loading = false;
    state.receivables = [];
    state.payables = [];
    state.form_invoice = {};
    state.form_user = null;
    state.form_recieve_account = [];
  },
};
